import React from 'react';
import { createStore } from 'little-state-machine';

import Amortizable from './steps/amortizable';
import Consumo from './steps/consumo';
import Tarjeta from './steps/tarjeta';
// import Automotor from './steps/automotor';
// import Hipotecario from './steps/hipotecario';
// import Personal from './steps/personal';

// import ClearButton from './components/ClearButton';
import { useGlobalData } from '../store';

import { STORE_NAME } from './config';
createStore({ data: {} }, { name: STORE_NAME });

const App = () => {
  const { globalData } = useGlobalData();

  return (
    <>
      {globalData.prestamo === 'amortizable' && <Amortizable />}
      {globalData.prestamo === 'consumo' && <Consumo />}
      {globalData.prestamo === 'tarjeta' && <Tarjeta />}
      {/* {globalData.prestamo === 'automotor' && <Automotor />} */}
      {/* {globalData.prestamo === 'hipotecario' && <Hipotecario />} */}
      {/* {globalData.prestamo === 'personal' && <Personal />} */}

      {/* <ClearButton /> */}
    </>
  );
};

export default App;
